import React from 'react'
import "./app.css"
import HomePage from './HomePage';
import Footer from './Components/Footer/Footer'
import Login from './login-signup/login/Login'
import SignUp from './login-signup/signup/SignUp';
import OfferPage from './Components/Offers/OfferPage/OfferPage';

import {createBrowserRouter, RouterProvider} from 'react-router-dom'

const router = createBrowserRouter([
  {
    path: '/',
    element : <div><HomePage/></div>,
  },
  {
    path: '/Login',
    element : <div><Login/></div>,
  },
  {
    path: '/SignUp',
    element : <div><SignUp/></div>,
  },
  {
    path: '/OfferPage/:id',
    element : <div><OfferPage/></div>,
  },
])

const App = () => {
  return (
    <>
      <div>
        <RouterProvider router={router}/>
      </div>
      <Footer/>
    </>
  )
}

export default App

